import formDate from 'date-fns/format';

type IFormat = 'dd.MM.yyyy' | 'HH:mm' | 'HH:mm / dd.MM.yyyy' | 'dd MMMM yyyy';

export const useFormDate = (
  dateStr: string,
  format: IFormat,
  currentNewDate?: string, // format '00-00-0000'
) => {
  const currentDate = new Date().toLocaleDateString('es-CL'); // this field view "0.00.00"
  const date = Date.parse(dateStr);

  const formatted = (date: number) => {
    if (date) return formDate(date, format);
  };

  const calculationsTime = (date: number) => {
    //calculations tomorrow or today or dayAfterTomorrow
    const currentDayNumber = currentDate.split('-')[0];
    const nextDayNumber = currentNewDate ? currentNewDate.split('-')[0] : formatted(date)?.split('.')[0];

    const delta = Number(nextDayNumber) - Number(currentDayNumber);

    const isTomorrowDate = delta === 1;
    const isToday = delta === 0;
    const isDayAfterTomorrow = delta > 1;

    return {isTomorrowDate, isDayAfterTomorrow, isToday};
  };

  return {
    date: formatted(date), // this field view "0.00.00"
    distanceDay: calculationsTime(date), // this fields view boolean value
  };
};

/**
 * This code will output the time range string "12:30 - 13:00"
 * @param initialDate ex: 2024-02-19T12:30:00+02:00
 * @returns "12:30 - 13:00"
 */
export const formatDatewith30Min = (initialDate: string) => {
  if (!initialDate) return '';
  const {addMinutes, parseISO, format} = require('date-fns');

  const dateString = initialDate;
  const startDate = parseISO(dateString);
  const endDate = addMinutes(startDate, 30);

  const startTimeString = format(startDate, 'HH:mm');
  const endTimeString = format(endDate, 'HH:mm');

  const timeRangeString = `${startTimeString} - ${endTimeString}`;
  return timeRangeString;
};
